import React, { lazy, Suspense } from 'react'
import { InfoSheet, Divider } from '@fs/zion-ui'
import type { useInfoSheet } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useFeatureFlag } from '@fs/zion-flags'
import DarkMode from './DarkMode'
import ContrastMode from './ContrastMode'

const ColumnLayoutSetting = lazy(() => import('./ColumnLayoutSetting'))
const SectionOrderSetting = lazy(() => import('./SectionOrderSetting'))

type Props = {
  infoSheetConfig: ReturnType<typeof useInfoSheet>
}

export default function SettingsInfoSheet({ infoSheetConfig }: Props): JSX.Element {
  const showDarkModeSetting = useFeatureFlag('treeweb_personR9_darkMode').isOn
  const [t] = useTranslation()
  const { isOpen, transitioning } = infoSheetConfig

  return (
    <InfoSheet title={t('tree-person.layout-settings.label')} {...infoSheetConfig} size="md">
      <Suspense fallback="">
        {(isOpen || transitioning) && <ColumnLayoutSetting />}
        <Divider marginY="xs" />
        {(isOpen || transitioning) && <SectionOrderSetting />}
        {showDarkModeSetting && (
          <>
            <Divider marginY="xs" />
            <DarkMode />
          </>
        )}
        <Divider marginY="xs" />
        <ContrastMode />
      </Suspense>
    </InfoSheet>
  )
}
